import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import AnyCollateralConfigFacet from '../abis/AnyCollateralConfigFacet';
import { getContractAddress } from '../constants';

export const getAnyCollateralConfigFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: AnyCollateralConfigFacet,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
